import React from "react";

/**
 * "Question N of M" label with a progress bar, for the shell's `progress` slot.
 *
 * @param {object} props
 * @param {number} props.current 1-based index of the question on screen.
 * @param {number} props.total
 */
const SurveyProgress = ({ current, total }) => {
  const percent = total ? Math.round((current / total) * 100) : 0;
  const text = `Question ${current} of ${total}`;

  return (
    <div>
      <div className="mb-2 flex items-center justify-between text-xs font-medium text-fg-muted">
        <span>{text}</span>
        <span aria-hidden="true">{percent}%</span>
      </div>
      <div
        role="progressbar"
        aria-label="Progress"
        aria-valuemin={1}
        aria-valuemax={total}
        aria-valuenow={current}
        aria-valuetext={text}
        className="h-2 overflow-hidden rounded-full bg-line"
      >
        <div
          className="h-full rounded-full bg-primary transition-[width] duration-300 ease-out dark:bg-accent"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
};

export default SurveyProgress;
